const FLEET_BY_COMPANY = {
  "Al Madina Logistics": [
    "2895/DK", "3734/WB", "867/BA", "5865/BK", "5439/AK", "247/DK",
    "8178/DK", "242/BK", "5427/AK", "9305/ML", "8269/WB", "1258/MR",
    "4451/MS", "2627/RH", "4947/DK", "5743/HK", "2578/RH", "2674/YM",
    "154/HK", "2925/WA", "7085/HW", "7530/YW", "6589/DS",
  ],
  "Al Mukhtar": [
    "3757/AK", "1589/WB", "9011/BA", "7178/HK", "4412/WA", "4090/DK",
    "3658/MS", "6927/YS", "8563/YS", "8259/DA", "6386/ML", "7606/WB",
    "795/MB", "2913/MB",
  ],
  OTO: [
    "5380/BK", "6641/MS", "1553/YS", "9537/YW", "2271/MS", "693/HA",
    "6655/RA", "8111/MS", "9192/MB", "4702/MA", "9637/AK", "8411/YR",
    "371/YM", "9906/MS", "3381/HW", "4896/BM", "8784/RA", "113/DS",
    "3467/DA", "6820/RA", "6905/MH", "5524/RH", "1323/MS", "2691/RA",
    "897/BM", "4611/ML", "4425/RA", "8089/RK", "193/RH", "3883/DA",
    "2817/ML", "7684/MH", "7135/RA", "4427/MR", "7025/MS", "980/MH",
    "4726/MA", "7745/MR", "7058/MH", "3218/MS", "1780/YS", "520/BM",
    "961/MH", "4093/HK", "277/MS", "9073/HW", "7378/YR", "1804/BA",
    "6807/MB", "3710/WK", "4985/YR", "7103/HA", "4520/HK", "629/YR",
    "3255/DK", "6502/MA", "7330/WK", "8938/YW", "1771/RA", "8524/WK",
    "1030/DA", "2557/YM", "5622/BK", "624/RA", "3847/MK", "4556/MK",
    "6678/MA", "4220/ML", "3526/MB", "5142/MB", "1550/MK", "3167/MD",
    "1477/MD", "144/RA", "9299/YW", "50/YM", "899/HM", "2227/WK",
    "8180/BM", "9742/RA", "9852/BM", "1324/BK", "6092/YD",
  ],
  Hamadan: ["1041/HK", "4501/YM", "5038/YW", "1372/HK"],
  "ASACS Group": ["6220/DK"],
  "Khazain Oil Field Transportation": [
    "6370/MD", "3988/YM", "1110/HW", "6670/WA", "2964/MA",
  ],
};

export const normalizeTruckNumber = (value) =>
  String(value || "").trim().toUpperCase().replace(/[^A-Z0-9]/g, "");

export const TRIP_FLEET = Object.entries(FLEET_BY_COMPANY).flatMap(
  ([carrier, trucks]) => trucks.map((truck) => ({
    truck,
    truckKey: normalizeTruckNumber(truck),
    carrier,
  }))
);

const FLEET_LOOKUP = new Map(TRIP_FLEET.map((item) => [item.truckKey, item]));

export const getFleetTruck = (value) => FLEET_LOOKUP.get(normalizeTruckNumber(value)) || null;
export const getCarrierByTruck = (value) => getFleetTruck(value)?.carrier || "";
export const formatApprovedTruck = (value) => getFleetTruck(value)?.truck || "";
export const TRIP_TRUCKS = TRIP_FLEET.map((item) => item.truck);
export const AMLS_TRUCKS = TRIP_FLEET.filter((item) => item.carrier === "Al Madina Logistics").map((item) => item.truck);
export const isAmlsTruck = (value) => getCarrierByTruck(value) === "Al Madina Logistics";
export const TRIP_CARRIERS = Object.keys(FLEET_BY_COMPANY);

